import { render, staticRenderFns } from "./ApprovalRejectionView.vue?vue&type=template&id=64ac2b34&scoped=true&"
import script from "./ApprovalRejectionView.vue?vue&type=script&lang=ts&"
export * from "./ApprovalRejectionView.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalRejectionView.vue?vue&type=style&index=0&id=64ac2b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac2b34",
  null
  
)

export default component.exports